import React from "react";

// Footer links to the public legal pages; opened in a new tab so forms keep their state.
const LegalLinks = ({ className = "" }) => (
  <div className={`flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs text-gray-500 ${className}`}>
    <span>© Dreamscape Innovations Pty Ltd</span>
    <a href="https://morphosys.io/terms/" target="_blank" rel="noopener noreferrer" className="underline hover:text-[#0099ff]">Terms of Service</a>
    <a href="https://morphosys.io/privacy/" target="_blank" rel="noopener noreferrer" className="underline hover:text-[#0099ff]">Privacy, Security &amp; AI Policy</a>
  </div>
);

export default LegalLinks;
